__turbopack_context__.v({
  "feed": "feed-module__0ecDbG__feed",
});
